import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    updatePath: String,
    updateParams: Object,
    updateParamKey: String,
    accept: { type: String, default: "text/vnd.turbo-stream.html" }
  }

  update () {
    const newValue = this.inputTarget.value.trim()

    const updatedRequest = JSON.parse(JSON.stringify(this.updateParamsValue))
    updatedRequest[Object.keys(updatedRequest)[0]][this.updateParamKeyValue] = newValue

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const headers = {
      "Content-Type": "application/json",
      Accept: this.acceptValue
    }
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    fetch(this.updatePathValue, {
      method: "PATCH",
      headers,
      body: JSON.stringify(updatedRequest)
    })
      .then(response => {
        if (!response.ok) {
          console.error("Editable select update failed", response)
          return
        }

        const contentType = response.headers.get("Content-Type") || ""
        if (contentType.includes("turbo-stream") && window.Turbo) {
          return response.text().then(html => window.Turbo.renderStreamMessage(html))
        }
      })
  }
}
